module.exports = __webpack_public_path__ + "img/noright.721aff91.png";